import React, {Component} from 'react';
import axios from 'axios';

const KEY = 'c9ae2c13187279ee786d6369b8618cb7';

class Notification extends Component {
	state = { temp: '25', desc: 'wind'};
	iconUrl = "http://openweathermap.org/img/wn/";

	componentDidMount(){
		this.getWeather();
	}
	
	getWeather = async (city) => {
		try {
			const response = await axios.create({
				baseURL: 'https://api.openweathermap.org/data/2.5',
			}).get('/weather', {
				params: {
					q: city,
					appid: KEY,
					units: 'metric',
				}
			});
			this.setState({
				temp: response.data.main.temp,
				desc: response.data.weather[0].description,
				icon: response.data.weather[0].icon
			});
		} catch (error) {
			console.error('Error fetching weather:', error);
			const response = await axios.create({
				baseURL: 'https://api.openweathermap.org/data/2.5',
			}).get('/weather', {
				params: {
					q: 'New York',
					appid: KEY,
					units: 'metric',
				}
			});
			this.setState({
				temp: response.data.main.temp,
				desc: response.data.weather[0].description,
				icon: response.data.weather[0].icon
			});
		}
    };

	componentDidMount() {
		this.getWeather(this.props.city);
	}

	componentDidUpdate(prevProps) {
		if (prevProps.city !== this.props.city) {
			this.getWeather(this.props.city);
		}
	}

	render() { 
		return ( 
			<span className="header-notif">Prediction of <b>{Math.round(this.state.temp)}°C</b> with <b>{this.state.desc}</b> in {this.props.city}</span>
			// <div className="header-notif">
			// 	<img className="header-notif-icon" src={this.iconUrl + this.state.icon + ".png"} alt={this.state.desc}/>
			// </div>
		 );
	}
}
 
export default Notification;